import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=936940b8&scoped=true"
import script from "./address-form.vue?vue&type=script&lang=ts"
export * from "./address-form.vue?vue&type=script&lang=ts"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./address-form.vue?vue&type=style&index=1&id=936940b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936940b8",
  null
  
)

export default component.exports